import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "pets";
export const initialState = {
    petsList: [],
    selectedPet: {
        id: 0,
        ownerId: 0,
        type: "CANINE",
        name: "",
        breed: "",
        weight: 0,
        sex: "",
        diet: [],
        neuteredSpayed: true,
        vaccines: [],
        medications: [],
        allergies: [],
        chronicConditions: [],
        dateOfBirth: "",
        imageUrl: "",
        environment: "",
        numLitterBoxes: "",
        clinicEmail: "",
        pharmacyName: "",
        pharmacyPhone: "",
    }
};

const petReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setSelectedPet: (state, action) => ({
            ...state,
            selectedPet: action.payload
        }),
        setPetImageURL: (state, action) => ({
            ...state,
            selectedPet: {
                ...state.selectedPet,
                imageUrl: action.payload
            }
        }),
        setPetsList: (state, action) => ({
            ...state,
            petsList: action.payload
        }),
        addPet: (state, action) => ({
            ...state,
            petsList: [...state.petsList, action.payload]
        }),
        removePet: (state, action) => ({
            ...state,
            petsList: [...state.petsList.filter(item => item.id !== action.payload.id)]
        }),
        clearPetStore: (state) => ({
            ...state,
            petsList: [],
        }),
    }
});

export default petReducer.reducer;
export const {
    setPetsList,
    addPet,
    removePet,
    setSelectedPet,
    setPetImageURL,
    clearPetStore
} = petReducer.actions;
